import React, { ReactElement } from "react";
import classNames from "classnames";
import Button from "components/Common/Button";
import colors from "stylesheets/utilities/colors.scss";

interface GreetingTypeProps {
  handleStyleSelect(style: string): void;
  getValue(key: string): string;
}

function GreetingType(props: GreetingTypeProps): ReactElement {
  const { getValue, handleStyleSelect } = props;

  return (
    <div className="Greeting__left-column__style">
      <span className="Greeting__left-column__label">
        Intro Type
      </span>
      <div className="Greeting__left-column__style__wrapper">
        <Button
          onClick={() => handleStyleSelect("Text")}
          customClassName={classNames(
            "Greeting__left-column__style__option",
            "Greeting__left-column__style__option--greeting-message", {
              "Greeting__left-column__style__option--selected":
                getValue("style") === "Text"
            }
          )}
          title="Message"
          text="Message"
          icon="Chat"
          light={getValue("style") !== "Text"}
          fillColor={getValue("style") === "Text" ? colors.colorUIPrimary : colors.colorBlack}
          center
        />
        <Button
          onClick={() => handleStyleSelect("Emoji")}
          customClassName={classNames(
            "Greeting__left-column__style__option",
            "Greeting__left-column__style__option--greeting-emoji", {
              "Greeting__left-column__style__option--selected":
                getValue("style") === "Emoji"
            }
          )}
          title="Emoji"
          text="Emoji"
          icon="Emoji"
          light={getValue("style") !== "Emoji"}
          fillColor={getValue("style") === "Emoji" ? colors.colorUIPrimary : colors.colorBlack}
          center
        />
      </div>
    </div>
  );
}

export default GreetingType;
